/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import { withRouter } from 'react-router-dom'

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Divider,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from "@material-ui/core";
import { Autocomplete } from '@material-ui/lab'
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

import logo from "../../assets/sainapse_logo2.png";

import Actions from '../../fluid/Actions/ActionFactory'

const CustomTextField = withStyles({
  root: {
    "& label": {
      color: "#FF6600",
    },
    "& label.Mui-focused": {
      color: "#FF6600",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#FF6600",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#AAAAAA",
        // color: "#FF6600",
      },
      "&:hover fieldset": {
        // borderColor: "#FFFFFF",
        // color: "#FF6600",
      },
      "&.Mui-focused fieldset": {
        // borderColor: "#FFFFFF",
        // color: "#FF6600",
      },
    },
  },
})(TextField);

const orangeTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#FF6600",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#dc004e",
      contrastText: "#fff",
    },
    text: {
      // primary: "#FFFFFF",
      // secondary: "#FFFFFF",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
    },
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = (theme) => ({
  bg: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center'
  },
  img_cont: {
    width: "100vw",
    height: "90vh",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
  },
  img: {
    display: "block",
    width: "100%",
    height: "auto",
  },
  loginContainer: {
    //width: "50vw",
    // height: "100vh",
    // display: "flex",
    // flexDirection: "row",
    //justifyContent : 'center',
    //alignItems: "center",
    backgroundColor: '#FFFFFF'
  },
  fieldColor: {
    color: "#FFFFFF",
  },
});

class Login extends Component {
  state = {
    email: "",
    password: "",
    auth_type : "",
    auth_loading : false,
    adaptors : [],
    showPassword: false,
  };

  componentDidMount () {
    console.log("From : ", this.props.location)
  }
 
  passwordFieldRef = React.createRef();

  handleClickShowPassword = () => {
    this.setState({
      ...this.state,
      showPassword: !this.state.showPassword,
    });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleChange = (value, name) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.passwordFieldRef.current.blur();
      this.props.handleAuth(this.state.email, this.state.password);
    }
  };

  getAdaptors = () => {
    this.setState({...this.state, auth_loading : true}, () => {
      Actions('http_request', {
        url : "/sainapse/security_adapter/names",
        method : "get",
        data : {}
      }).then(res => {
        let adaptors = res.data.result
        console.log('Adaptors : ', adaptors)
        this.setState({...this.state, auth_loading : false, adaptors : adaptors})
      })
    })
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.bg}>
        <div
          style={{
            padding: "20px",
            width: "100vw",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px"
          }}
        >
          <img style={{ height: "75px" }} src={logo} alt="logo" />
        </div>
        <div className={classes.loginContainer}>
          <div
            style={{
              width: "100vw",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Paper
              elevation={12}
              style={{
                width: "24vw",
                padding: "15px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h4">Login</Typography>
              </div>
              <Divider
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  backgroundColor: "#3761BF",
                }}
              />
              <ThemeProvider theme={blue_theme}>
                <TextField
                  id = "login-email"
                  label="Email/Username"
                  size="small"
                  type="email"
                  value={this.state.email}
                  variant="outlined"
                  onChange={(event) =>
                    this.handleChange(event.target.value, "email")
                  }
                  style={{
                    marginTop: "15px",
                    marginBottom: "15px",
                    width: "100%",
                    color: "#FFFFFF",
                  }}
                  // InputProps={{
                  //   className: classes.fieldColor,
                  // }}
                />
                <TextField
                  id = "login-password"
                  label="Password"
                  size="small"
                  variant="outlined"
                  inputRef={this.passwordFieldRef}
                  type={this.state.showPassword ? "text" : "password"}
                  value={this.state.password}
                  onChange={(event) =>
                    this.handleChange(event.target.value, "password")
                  }
                  onKeyPress={this.handleKeyPress}
                  style={{
                    marginTop: "15px",
                    marginBottom: "15px",
                    width: "100%",
                    color: "#FFFFFF",
                  }}
                  InputProps={{
                    // className: classes.fieldColor,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          style={{ color: "#AAAAAA" }}
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Autocomplete
                    id="tags-standard"
                    options={this.state.adaptors}
                    value = {this.state.auth_type}
                    onOpen = {() => this.getAdaptors()}
                    onChange = {(event, newValue) => this.handleChange(newValue, 'auth_type')}
                    loading = {this.state.auth_loading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Authentication"
                        variant = 'outlined'
                        size = 'small'
                      />
                    )}
                />
              </ThemeProvider>
              {this.props.invalidCredentials ? (
                <Typography color="secondary" variant="caption">
                  {this.props.invalidCredentialsErrorMessage}
                </Typography>
              ) : null}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "15px",
                }}
              >
                <div style={{ width: "100%" }}>
                  <Button
                    id = "login-button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      this.props.handleAuth(
                        this.state.email,
                        this.state.password,
                        this.state.auth_type
                      )
                    }
                  >
                    Login
                  </Button>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(Login));
